import { render, staticRenderFns } from "./PostAutor.vue?vue&type=template&id=18da7098&scoped=true"
import script from "./PostAutor.vue?vue&type=script&lang=js"
export * from "./PostAutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da7098",
  null
  
)

export default component.exports